import { HorizontalAlignmentOptions, RatioOptions, TextStyleOptions, VerticalAlignmentOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';
import { NICmsContentPageType } from '@icms/core/content/interfaces/icms-content-page-type.interfaces';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../catalog/config/component.config';
import { NCmsBlogCategory } from '../category/cms-blog-category.interface';
import { BLOG_TAB } from '../root/cms-blog-root.interface';
import { EPageVariant, NCmsBlogPost } from './cms-blog-post.interface';

export const CMS_BLOG_POST_CONFIG = <NICmsContentPageType.IMeta>{
    id: NCmsBlogPost.typeId,
    title: 'Blog post',
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'typeData.variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Page layout',
            default: 'var_1',
            options: [
                { key: EPageVariant.var_1, title: '(1) Image and copy with title and date' },
                { key: EPageVariant.var_2, title: '(2) Image with overlapping copy' }
            ],
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'typeData.title',
            title: 'Title',
            tab: BLOG_TAB
        },
        <NICmsContentField.IChoiceField>{
            key: 'typeData.title_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Set title style',
            options: TextStyleOptions,
            default: 'h2',
            tab: BLOG_TAB,
            canShow: model => model.typeData.variant === EPageVariant.var_1
        },
        {
            type: NICmsContentField.EFieldType.date,
            key: 'typeData.date',
            title: 'Post publication date',
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'typeData.short_description',
            title: 'Listing page summary',
            description: 'Appears where listing posts',
            tab: BLOG_TAB
        },
        <NICmsContentField.IChoiceField>{
            key: 'typeData.copy_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Set description style',
            options: TextStyleOptions,
            default: 'p1',
            tab: BLOG_TAB,
            canShow: model => model.typeData.variant === EPageVariant.var_1
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'typeData.copy',
            title: 'Top section copy',
            tab: BLOG_TAB
        },
        <NICmsContentField.IChoiceField>{
            key: 'typeData.horizontal_text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Horizontal text alignment',
            options: HorizontalAlignmentOptions,
            default: 'center',
            tab: BLOG_TAB,
            canShow: model => model.typeData.variant === EPageVariant.var_1
        },
        <NICmsContentField.IChoiceField>{
            key: 'typeData.vertical_text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Vertical text alignment',
            options: VerticalAlignmentOptions,
            default: 'middle',
            tab: BLOG_TAB,
            canShow: model => model.typeData.variant === EPageVariant.var_1
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'typeData.image',
            title: 'Main image',
            description: 'Used on listings, and as top section image on post page',
            required: true,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.choice,
            key: 'typeData.image_ratio',
            title: 'Image ratio',
            options: RatioOptions,
            default: 'ratio-3-4',
            required: true,
            tab: BLOG_TAB,
            canShow: model => model.typeData.variant === EPageVariant.var_1
        },
        {
            key: 'typeData.primary_tag',
            type: NICmsContentField.EFieldType.text,
            title: 'Primary Blog Post tag',
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.show_related',
            title: 'Show related articles',
            description: 'When enabled will show 3 last articles with the same parent page',
            default: true,
            tab: BLOG_TAB
        },
        <NICmsContentField.IComponentsField>{
            key: 'typeData.topComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Top section components (wrapped)',
            itemName: 'component',
            default: [],
            tab: BLOG_TAB
        },
        <NICmsContentField.IComponentsField>{
            key: 'components',
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'Component',
            default: []
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-meta',
            title: 'Meta'
        },
        <NICmsContentField.IField>{
            key: 'typeData.hide_meta_title_suffix',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide meta title suffix',
            default: false,
            tab: BLOG_TAB
        },
        ...CMS_COMPONENT_CWV_CONFIG.map(field => {
            return {
                ...field,
                key: `typeData.${field.key}`,
                tab: BLOG_TAB
            };
        })
    ],
    initData: {
        components: []
    },
    /**
     * Only allow parent page to be blog-category
     */
    parentFilter: page => {
        return page.rawData?.pageType === NCmsBlogCategory.typeId;
    }
};
